<template>
  <input-select
    v-if="catalogId"
    class="mb-1"
    :value="value"
    :disabled="disabled"
    :options="colorOptions"
    placeholder="Select a color"
    @input="(v) => this.$emit('input', v)"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import InputSelect from '@/components/Form/InputSelect';

export default {
  name: "ColorOption",
  components: {
    InputSelect,
  },
  props: [
    "catalogId",
    "value",
    "disabled",
  ],
  computed: {
    ...mapGetters({
      mockupOptions: "upload/mockupOptions",
    }),
    colorOptions() {
      const catalogType = this.mockupOptions.find(item => item.value == this.catalogId);
      return catalogType.colors.map(item => ({
        text: item.split('_').map(x => _.capitalize(x)).join(' '),
        value: item
      }));
    },
  },
};
</script>
